import {
  ContributorsScheduleDocument,
  ContributorsScheduleQuery,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { FooterElement } from 'modules/project_management/components/Schedule/Footer/index'
import Schedule from 'modules/project_management/components/Schedule/index'
import { ScheduleOnboardingHint } from 'modules/project_management/components/hints/schedule/ScheduleOnboarding'

import { parseData } from './parseData'

const ContributorsSchedule = () => {
  useEffect(() => {
    track(trackingEvents.projectManagement.schedule.viewSchedulePage, {})
  }, [])

  const dataSource = (data: ContributorsScheduleQuery) => {
    const connection = data?.projectManagement.projectContributorsConnection
    return {
      edges:
        connection?.edges.map((edge) => ({
          cursor: edge.cursor ?? '',
          node: edge.node,
        })) ?? [],
      pageInfo: {
        hasNextPage: connection?.pageInfo.hasNextPage ?? false,
        endCursor: connection?.pageInfo.endCursor ?? '',
      },
    }
  }

  const footerElementsList: FooterElement[] = [
    {
      color: 'champagne400',
      circleType: 'circle',
      description: i18n.t('project_management.schedule_contributors.footer_legend.time_off'),
    },
    {
      color: 'purple200',
      circleType: 'circle',
      description: i18n.t(
        'project_management.schedule_contributors.footer_legend.total_assigned_hours'
      ),
    },
    {
      color: 'purple1000',
      circleType: 'circle-line',
      description: i18n.t(
        'project_management.schedule_contributors.footer_legend.detailed_hours_per_project'
      ),
    },
  ]

  return (
    <>
      <ScheduleOnboardingHint />

      <Schedule
        document={ContributorsScheduleDocument}
        documentVariables={{ employeeIds: [], startDate: '2025-03-01', endDate: '2025-03-29' }}
        dataSource={dataSource}
        parseData={parseData}
        footerLegend={footerElementsList}
      />
    </>
  )
}

export default ContributorsSchedule
